import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';

export function useDeleteUserPlant() {
  return useMutation(api.plants.mutations.deleteUserPlant).withOptimisticUpdate(
    (localStore, args) => {
      const current = localStore.getQuery(api.plants.queries.getAllPlants, {});
      if (current === undefined) return;

      const plantId = String(args.userPlantId);
      localStore.setQuery(
        api.plants.queries.getAllPlants,
        {},
        current.filter((plant) => plant.id !== plantId)
      );
    }
  );
}
